<template src='./pif1-5-2.html'></template>

<script>
import Vue from 'vue'
import { EventBus } from '@/router/bus'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import { JSONEditor } from '@json-editor/json-editor/'
import SimpleMDE from 'simplemde/dist/simplemde.min.js'
import { hasAdminClaim, hasProjectManageClaim, authorizedOrganizationId } from '@/router/auth'

// const DISPLAY = 'display'

export default {
  components: {
    ContextPage,
    SimpleMDE
  },
  data () {
    return {
      markFields: 18,
      showErrorPanel: false,
      jsonDialog: false,
      jsonScheme: null,
      validationErrors: [],
      autoCompleteUrl_budgetId: Vue.$apiConfig.budgetUsersGet,
      resultContent: null,
      initialSchema: {},
      initialEditor: {},
      initialConfig: {},
      initialVal: {},
      initialMarks: {},
      pif: null,
      errorPanel: null,
      editor: null,
      projectCode: this.$route.params.projectCode,
      projectPhaseId: this.$route.params.projectPhaseId,
      phaseFormId: this.$route.params.phaseFormId,
      formId: null,
      formStatus: 0,
      project: {},
      projectForm: null,
      loading: false,
      ProjectStatus: {
        DRAFT: 1,
        CREATED: 2,
        ACCEPTED: 3
      },
      FormInputAction: {
        SAVE: 1,
        LOCKSAVE: 2,
        UNLOCKSAVE: 3,
        MARK: 4,
        LOCKMARK: 5,
        UNLOCKMARK: 6
      },
      FormInputStatus: {
        UNLOCKED: 1,
        LOCKED: 2,
        MARKED: 3,
        APPROVED: 4
      },
      status: [
        {
          color: 'pending',
          text: this.$t('projects.formStatuses.1')
        },
        {
          color: 'active-light',
          text: this.$t('projects.formStatuses.2')
        },
        {
          color: 'active-light',
          text: this.$t('projects.formStatuses.3')
        },
        {
          color: 'success',
          text: this.$t('projects.formStatuses.4')
        }
      ],
      markdownElements: [
        {
          editor: 'root.A',
          element: 'root[A]',
          name: 'A'
        },
        {
          editor: 'root.B',
          element: 'root[B]',
          name: 'B'
        },
        {
          editor: 'root.V',
          element: 'root[V]',
          name: 'V'
        }
      ]
    }
  },
  computed: {
    isAdmin () {
      return hasAdminClaim()
    },
    canManageProject () {
      return hasProjectManageClaim()
    },
    userOrganizationId () {
      return authorizedOrganizationId()
    },
    canEditProject () {
      return this.formStatus === this.FormInputStatus.UNLOCKED && this.canManageProject && this.userOrganizationId === this.project.organizationId && Number(this.projectPhaseId) === this.project.projectPhaseId
    },
    canUnlockProject () {
      return this.formStatus === this.FormInputStatus.LOCKED && this.canManageProject && this.userOrganizationId === this.project.organizationId && Number(this.projectPhaseId) === this.project.projectPhaseId
    }
  },
  methods: {
    validateFormInput () {
      const errors = this.editor.validate()
      if (errors && errors.length > 0) {
        this.validationErrors = errors
        this.showErrorPanel = true
        this.$nextTick(function () {
          this.scrollToErrorPanel()
        })
      }
    },
    submitFormInput (action) {
      this.loading = true
      const values = this.editor.getValue()
      for (var i = 0; i < this.markdownElements.length; i++) {
        values[this.markdownElements[i].name] = this.editor.getEditor(this.markdownElements[i].editor).simplemde_instance.value()
      }
      this.projectForm = {
        projectCode: this.projectCode,
        projectPhaseId: this.projectPhaseId,
        id: this.phaseFormId,
        formId: this.formId,
        json: JSON.stringify(values),
        action: action
      }
      this.$http.post(Vue.$apiConfig.projectInputFormPost, this.projectForm)
        .then(
          response => {
            this.logConsole(response)
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('projects.submitProjectFormInputSuccessful'),
              errors: []
            })
            this.setupPage()
            this.loading = false
          },
          error => {
            this.formatErrorResponse(error)
            this.loading = false
          }
        )
    },
    fetch (query) {
      const queryParamName = 'search'
      const url = this.autoCompleteUrl_budgetId
      const params = Object.assign({ [queryParamName]: query })
      const cancel = new Promise((resolve) => (this.cancel = resolve))
      const request = this.$http.get(url, { params })

      return Promise.race([cancel, request])
    },
    cancel () {
      // used to 'cancel' previous searches
    },
    setupPage () {
      this.loading = true
      this.$http.get(Vue.$apiConfig.inputFormGet.replace('{projectCode}', this.$route.params.projectCode) + '/forms/' + this.phaseFormId)
        .then(
          response => {
            this.logConsole(response)
            const payload = response.data.payload
            const formInput = payload.projectFormInput
            this.formStatus = formInput.status
            this.formId = payload.projectForm.id
            this.pif = JSON.parse(payload.projectForm.json)
            this.initialSchema = this.pif.schema
            this.initialConfig = this.pif.config
            this.initialVal = formInput.inputJson ? JSON.parse(formInput.inputJson) : null
            this.initializeEditor()
            this.loading = false
          },
          error => {
            this.formatErrorResponse(error)
            this.loading = false
          }
        )
    },
    initializeEditor () {
      const el = document.getElementById('editorHolder')
      this.initialConfig.schema = this.initialSchema
      this.initialConfig.no_additional_properties = true
      if (this.formStatus === this.FormInputStatus.LOCKED) {
        this.initialConfig.disable_array_add = true
        this.initialConfig.disable_array_delete = true
        this.initialConfig.disable_array_delete_all_rows = true
        this.initialConfig.disable_array_delete_last_row = true
        this.initialConfig.disable_array_reorder = true
      }
      if (this.editor) { this.editor.destroy() }
      this.editor = new JSONEditor(el, this.initialConfig)
      this.resultContent = this.initialEditor

      this.editor.on('ready', () => {
        for (var j = 0; j < this.markdownElements.length; j++) {
          this.editor.getEditor(this.markdownElements[j].editor).simplemde_instance.toTextArea()
          this.editor.getEditor(this.markdownElements[j].editor).simplemde_instance = null
          const config = {
            element: document.getElementsByName(this.markdownElements[j].element)[0],
            spellChecker: false,
            hideIcons: ['heading'],
            autosave: { enabled: true },
            showIcons: ['heading-2', 'heading-3', 'horizontal-rule', 'code', 'table'],
            status: ['autosave', 'lines', 'words', 'cursor']
          }
          if (!this.canEditProject) { config.toolbar = false }
          this.editor.getEditor(this.markdownElements[j].editor).simplemde_instance = new SimpleMDE(config)
        }
        if (this.initialVal) {
          // if (this.initialMarks) { Object.assign(this.initialVal, this.initialMarks) }
          this.saveJsonValues(this.initialVal)
        }
        this.manageInput()
      })
      this.editor.element.children[0].children[2].className = 'hidden-panel'
      console.log(this.editor)
    },
    manageInput () {
      if (this.isAdmin) { return }
      if (!this.canEditProject) {
        this.editor.disable()
        for (var j = 0; j < this.markdownElements.length; j++) { this.editor.getEditor(this.markdownElements[j].editor).simplemde_instance.togglePreview() }
      }
    },
    openJsonDialog () {
      this.jsonScheme = JSON.stringify(this.editor.getValue(), null, 2)
      this.jsonDialog = true
    },
    closeJsonDialog () {
      this.saveJsonValues(JSON.parse(this.jsonScheme))
      this.jsonDialog = false
    },
    saveJsonValues (jsonScheme) {
      for (const key in jsonScheme) {
        var property = this.editor.getEditor('root.' + key)
        if (property) {
          property.setValue('')
          property.setValue(jsonScheme[key])
        }
      }
    },
    extractErrorItem (message) {
      var regExp = /'[0-9]+'/
      return regExp.exec(message)[0]
    },
    scrollToErrorPanel () {
      const element = this.$refs.errorPanel
      var top = element.offsetTop

      window.scrollTo(0, top)
    }
  },
  created () {
    this.setupPage()
  }
}
</script>

<style>
.v-chip {
  font-weight: 600 !important;
  /* font-size: 20px !important */
}
.item-container {
  font-weight: 600 !important;
  font-size: 15px !important;
}

.drop-menu-item {
  margin: 0 0 0 50px;
}
.claim-item {
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.02em;
  font-family: 'Source Sans Pro', sans-serif;
  margin-left: 30px;
}

.centered-label {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.list-container {
  height: 264px;
  overflow-y: auto;
  font-size: 11pt;
  border: 1px solid rgba(0, 0, 0, .12);
}
.autocomplete-result {
  background-image: none !important;
  padding-left: 10px !important;
}
.hidden-panel {
  display: none !important;
}
</style>
